import CompanyRoutes from './route-types'

const CompanyOnboardingView = () => import(/* webpackChunkName: "company-onboarding-chunk" */ './onboarding/CompanyOnboardingView')
const CompanyMenuVersionAccess = () => import(/* webpackChunkName: "company-onboarding-chunk" */ './onboarding/CompanyMenuVersionAccess')
const CompanyEnableNewMenu = () => import(/* webpackChunkName: "company-onboarding-chunk" */ './onboarding/CompanyEnableNewMenu')
const CompanyUpdateUserAccess = () => import(/* webpackChunkName: "company-onboarding-chunk" */ './onboarding/CompanyUpdateUserAccess')
const CompanyEmailRouteManage = () => import(/* webpackChunkName: "company-onboarding-chunk" */ './onboarding/CompanyEmailRouteManage')
const CompanySetting = () => import(/* webpackChunkName: "company-onboarding-chunk" */ './onboarding/CompanySetting')
const NewFeaturesControl = () => import(/* webpackChunkName: "company-onboarding-chunk" */ './onboarding/NewFeaturesControl')
const CompanyBusinessHours = () => import(/* webpackChunkName: "company-onboarding-chunk" */ './onboarding/CompanyBusinessHours')
const CompanyRepxStagesSettings = () => import(/* webpackChunkName: "company-onboarding-chunk" */ './onboarding/CompanyRepxStagesSettings')
const CompanyRepxStagesMappingSetup = () => import(/* webpackChunkName: "company-onboarding-chunk" */ './onboarding/CompanyRepxStagesMappingSetup')
const CompanyORMUtilities = () => import(/* webpackChunkName: "company-onboarding-chunk" */ './onboarding/CompanyOrmUtilities')
const SubJobStageSetup = () => import(/* webpackChunkName: "company-onboarding-chunk" */ './onboarding/SubJobStageSetup')

export default [
  {
    path: CompanyRoutes.CompanyMenuVersionAccess.path,
    name: '',
    component: CompanyOnboardingView,
    meta: {
      title: 'Company Onboarding',
      name: 'Company Onboarding'
    },
    children: [
      {
        path: '',
        name: CompanyRoutes.CompanyMenuVersionAccess.name,
        component: CompanyMenuVersionAccess,
        meta: {
          title: 'Menu Version Access',
          name: 'Menu Version Access'
        }
      },
      {
        path: CompanyRoutes.CompanyEnableNewMenu.path,
        name: CompanyRoutes.CompanyEnableNewMenu.name,
        component: CompanyEnableNewMenu,
        meta: {
          title: 'Menu Version Access',
          name: 'Menu Version Access'
        }
      },
      {
        path: CompanyRoutes.CompanyUpdateUserAccess.path,
        name: CompanyRoutes.CompanyUpdateUserAccess.name,
        component: CompanyUpdateUserAccess,
        meta: {
          title: 'Update User Access',
          name: 'Update User Access'
        }
      },
      {
        path: CompanyRoutes.CompanyEmailRouteManage.path,
        name: CompanyRoutes.CompanyEmailRouteManage.name,
        component: CompanyEmailRouteManage,
        meta: {
          title: 'Email Route Manage',
          name: 'Email Route Manage'
        }
      },
      {
        path: CompanyRoutes.CompanySetting.path,
        name: CompanyRoutes.CompanySetting.name,
        component: CompanySetting,
        meta: {
          title: 'Company Setting',
          name: 'Company Setting'
        }
      },
      {
        path: CompanyRoutes.NewFeaturesControl.path,
        name: CompanyRoutes.NewFeaturesControl.name,
        component: NewFeaturesControl,
        meta: {
          title: 'New Features Control',
          name: 'New Features Control'
        }
      },
      {
        path: CompanyRoutes.CompanyBusinessHours.path,
        name: CompanyRoutes.CompanyBusinessHours.name,
        component: CompanyBusinessHours,
        meta: {
          title: 'Business Hours',
          name: 'Business Hours'
        }
      },
      {
        path: CompanyRoutes.CompanyRepxStagesSettings.path,
        name: CompanyRoutes.CompanyRepxStagesSettings.name,
        component: CompanyRepxStagesSettings,
        meta: {
          title: 'RepX Stages Settings',
          name: 'RepX Stages Settings'
        }
      },
      {
        path: CompanyRoutes.CompanyRepxStagesMappingSetup.path,
        name: CompanyRoutes.CompanyRepxStagesMappingSetup.name,
        component: CompanyRepxStagesMappingSetup,
        meta: {
          title: 'RepX Stages Setup',
          name: 'RepX Stages Setup',
          access: {
            isEdit: true
          }
        }
      },
      {
        path: CompanyRoutes.CompanyORMUtilities.path,
        name: CompanyRoutes.CompanyORMUtilities.name,
        component: CompanyORMUtilities,
        meta: {
          title: 'Orm Utilities',
          name: 'Orm Utilities'
        }
      },
      {
        path: CompanyRoutes.SubJobStageSetup.path,
        name: CompanyRoutes.SubJobStageSetup.name,
        component: SubJobStageSetup,
        meta: {
          title: 'Sub Job Stage',
          name: 'Sub Job Stage',
          access: {
            isEdit: true
          }
        }
      }
    ]
  }

  // {
  //   path: CompanyRoutes.CompanyEnableNewMenu.path,
  //   name: CompanyRoutes.CompanyEnableNewMenu.name,
  //   component: CompanyEnableNewMenu,
  //   meta: {
  //     title: 'Company New Menu Access',
  //     name: 'Company New Menu Access'
  //   }
  // }
]
